import { net_filemanage } from "@/api/http";
export const API_STFMFM02C17_FileUpload = (...params) =>
net_filemanage.post("/api/STFMFM02C17/FileUpload", ...params)